define('modules/auth/reset/views/reset.password.view',[
    'jquery',
    'underscore',
    'backbone',
    'modules/base/models/auth.password.model',
    'modules/base/models/default.token.model',
    'modules/base/views/model.view',
    'text!modules/auth/reset/templates/reset.password.template.html'
], function(
    $,_,Backbone,
    AuthPasswordModel,
    TokenModel,
    ModelView,
    Template
){
    var ResetPasswordView = ModelView.extend({
        className:'resetPasswordPanel unAuthView',
        mainBtnLoaderRestingText: 'Reset',
        mainBtnLoaderWorkingText: 'Resetting',
        template:_.template(Template),
        mEvents: function(){
            var base = {
                'keyup'         : 'procKeyOnEnter'
            };
            var click = {
                'click .relpro-logo' : 'login',
                'click .sloganWhite' : 'login'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options) {
            this.debugName = 'reset password controller';
            this.resetPwd = new AuthPasswordModel();
            ModelView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new TokenModel();
        },
        procResponse: function() {
            this.$('#userNonce').val(window.token.get('nonce'));
        },
        procKeyOnEnter: function(event) {
            var keypressed = event.keyCode || event.which;
            keypressed = (keypressed == 'undefined') ? window.event : keypressed;
            if (keypressed == 13) { this.mainBtn(); }
        },
        procMainBtn:function() {
            this.$('.loadingMsg').html("");
            if (window.utils.validation.isValidEmail(this.$('#userEmail').val())) {
                this.resetPwd.set(
                    {
                        email      : this.$('#userEmail').val()
                    }
                );
                this.resetPwd.once('sync', this.mainBtnResponse, this);
                this.resetPwd.save({wait: true});
            } else {
                this.errOut('Email is invalid');
                this.removeMainBtnLoader();
            }
        },
        procMainBtnResponse: function() {
            if(this.resetPwd.has("error")){
                this.$('.loadingMsg').html("Error: " + this.resetPwd.get("error").message);
                this.resetPwd.set({error: undefined});
            } else {
                this.$('.navHolder').hide();
                this.$('.inputContainer').hide();
                this.$('.msgOut p').html('Email Sent! Click the reset password link in the email we just sent you.');
                this.$('.msgOut').append("<p>If you don't receive the invite, please contact: <a class='clickable' href='mailto:support@relpro.com'>support@relpro.com</a></p>");
                if(window.location.origin.toLowerCase().indexOf("localhost") > -1){
                    window.location.href = "http://localhost/loginClientUI/";
                } else if(window.location.origin.toLowerCase().indexOf("lstaging.relpro.com") > -1){
                    this.$('.login').html("<p>I know my password, <a class='clickable' href='https://lstaging.relpro.com'>log in</a></p>");
                } else if(window.location.origin.toLowerCase().indexOf("ltest.relpro.com") > -1){
                    this.$('.login').html("<p>I know my password, <a class='clickable' href='https://ltest.relpro.com'>log in</a></p>");
                } else if(window.location.origin.toLowerCase().indexOf("ptlogin.relpro.com") > -1){
                    this.$('.login').html("<p>I know my password, <a class='clickable' href='https://ptlogin.relpro.com'>log in</a></p>");
                } else {
                    this.$('.login').html("<p>I know my password, <a class='clickable' href='https://login.relpro.com'>log in</a></p>");
                }
            }
        }

    });
    return ResetPasswordView;
});


